/**
 * Token Manager Service
 * Handles access token, refresh token, and token refresh logic
 */


const PKCE_STORAGE_KEY = 'pkce_flow';

/**
 * Store PKCE flow data
 * @param {object} data - { codeVerifier, state }
 */
export const storePkceFlowData = (data) => {
  localStorage.setItem(PKCE_STORAGE_KEY, JSON.stringify(data));
};

/**
 * Get PKCE flow data
 * @returns {object|null} PKCE flow data or null
 */
export const getPkceFlowData = () => {
  try {
    const data = localStorage.getItem(PKCE_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    return null;
  }
};

/**
 * Clear PKCE flow data
 */
export const clearPkceFlowData = () => {
  localStorage.removeItem(PKCE_STORAGE_KEY);
};
